const ProductionLines = () => import("Modules/configuration/production/views/ProductionLines");
const ProductionStations = () => import("Modules/configuration/production/views/ProductionStations");
const ProductionProcedures = () => import("Modules/configuration/production/views/ProductionProcedures");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "configuration/production_lines",
            name: "settings_production_lines",
            component: ProductionLines,
            meta: {
                requiresAuth: true,
                title: "lang.production_lines",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "configuration/production_stations",
            name: "settings_production_stations",
            component: ProductionStations,
            meta: {
                requiresAuth: true,
                title: "lang.production_stations",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "configuration/production_procedures",
            name: "settings_production_procedures",
            component: ProductionProcedures,
            meta: {
                requiresAuth: true,
                title: "lang.production_procedures",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
